<template lang='slm'>
.bz-paragraph :class='columnsClass()'
  .row v-if="localized('title')"
    .col-12 :style='titleStyle()'
      component :is="titleTag()" v-text="localized('title')"
  .row
    component :is="tagByModel(child[0])" v-for="child in children" :id="child[1]" :key="compoundKey(...child)"
</template>

<script>
import BzTreeItem from '@/components/mixins/bz-tree-item'
import BzText from '@/components/bz-tree/BzText'

export default {
  name: 'bz-paragraph',
  mixins: [ BzTreeItem ],
  components: { BzText },
  methods: {
    columnsClass () {
      let columns = this.bzData && this.bzData.style && this.bzData.style.columns
      if (columns !== undefined) {
        let compoundClass = []
        columns.large && compoundClass.push(`col-lg-${columns.large}`)
        columns.middle && compoundClass.push(`col-md-${columns.middle}`)
        columns.small && compoundClass.push(`col-sm-${columns.small}`)
        if (typeof columns === 'number') {
          compoundClass.push(`col-${columns}`)
        }
        return compoundClass.join(' ')
      }
      return 'col-12'
    },
    titleTag () {
      let level = (this.level || 3) + 1
      return `h${level}`
    },
    titleStyle () {
      let titleStyle = this.bzData && this.bzData.style && this.bzData.style.title
      return titleStyle
    }
  }
}
</script>
<style scoped lang='scss'>

</style>



// WEBPACK FOOTER //
// src/components/bz-tree/BzParagraph.vue